<template>
  <div class="add-name-modal">
    <div v-if="loadModal" class="modal modal-mask">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header div-responsive">
            <div class="modal-title">
              <h1>Examinee Name</h1>
            </div>
            <button type="button" class="close-icon" @click="handleModal($event)" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <form autocomplete="off">
            <div class="modal-body div-responsive">
              <div class="box-body">
                <div class="box-row">
                  <div class="box-col box-col-left">First Name</div>
                  <div class="box-col box-col-right">
                    <input @keyup.enter="clickSave" id="firstname" name="firstname" autocomplete="given-name" type="text"
                           :class="hasError && firstNameError ? 'is-invalid' : ''" v-model="nameObject.firstName" placeholder="First Name"
                           @blur="trimField('firstName')" />
                    <div class="text-danger" v-if="hasError && firstNameError">{{ firstNameError }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">Middle Name/s</div>
                  <div class="box-col box-col-right">
                    <input @keyup.enter="clickSave" id="additional-name" name="additional-name" autocomplete="additional-name" type="text"
                           :class="hasError && middleNameError ? 'is-invalid' : ''" v-model="nameObject.middleName" placeholder="Middle Name/s"
                           @blur="trimField('middleName')" />
                    <div class="text-danger" v-if="hasError && middleNameError">{{ middleNameError }}</div>
                  </div>
                </div>
                <div class="box-row">
                  <div class="box-col box-col-left">Surname</div>
                  <div class="box-col box-col-right">
                    <input @keyup.enter="clickSave" id="family-name" name="family-name" autocomplete="family-name" type="text"
                           :class="hasError && surnameError ? 'is-invalid' : ''" v-model="nameObject.surname" placeholder="Surname"
                           @blur="trimField('surname')" />
                    <div class="text-danger" v-if="hasError && surnameError">{{ surnameError }}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="icon-group right-float-element">
                    <v-btn class="white-button" @click="handleModal($event)" dark>Cancel</v-btn>
                    <v-btn @click="clickSave" dark>Save</v-btn>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'

  export default {
    name: 'AddNameModal',
    props: ['typrProps', 'clientProps'],
    data() {
      return {
        nameObject: {
          firstName: "",
          middleName: "",
          surname: "",
        },
        loadModal: false,
        hasError: false,
        loaded: false,
        isNew: false,
        isEdit: false,
      }
    },

    computed: {
      firstNameError() {
        return utilities.getClientContactPersonNameError(this.nameObject.firstName, 'First name')
      },
      middleNameError() {
        return utilities.getClientContactMiddleNameError(this.nameObject.middleName)
      },
      surnameError() {
        return utilities.getClientContactPersonNameError(this.nameObject.surname, 'Surname')
      },
    },

    methods: {
      trimField(part) {
        const key = part === 'firstName' ? 'firstName' : part === 'middleName' ? 'middleName' : 'surname'
        const v = this.nameObject[key]
        if (v === undefined || v === null) return
        this.nameObject[key] = String(v).trim()
      },
      handleModal(e) {
        this.loadModal = !this.loadModal
        if (this.loadModal) {
          $('html').addClass('modal-mask-open')
        } else {
          $('html').removeClass('modal-mask-open')
        }
      },

      addName() {
        this.isEdit = false
      },

      editFullName(firstName, middleName, surname) {
        this.isEdit = true
        this.nameObject.firstName = firstName
        this.nameObject.middleName = middleName
        this.nameObject.surname = surname
      },

      saveFullName() {},

      async clickSave() {
        this.trimField('firstName')
        this.trimField('middleName')
        this.trimField('surname')
        this.hasError = false
        if (this.firstNameError || this.middleNameError || this.surnameError) {
          this.hasError = true
          return
        }
        this.$emit('setName', this.nameObject)
        this.handleModal()
      },
    },
    beforeMount() {},
    mounted() {},
  }
</script>
